import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { X, Phone, ChevronDown } from 'lucide-react';

export default function MenuSidebar({ isOpen, onClose }) {
    const [openDropdown, setOpenDropdown] = useState('');
    const location = useLocation();

    const toggleDropdown = (name) => {
        setOpenDropdown(openDropdown === name ? '' : name);
    };

    return (
        <div
            className={`fixed inset-y-0 left-0 w-full bg-surface text-primary z-50 lg:z-10 flex flex-col justify-between overflow-hidden transition-transform duration-700 ease-[cubic-bezier(0.76,0,0.24,1)] ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}
        >
            <div className="w-full h-full flex flex-col justify-between overflow-y-auto relative z-20">
                {/* Background Decor */}
                {/* <div className="absolute inset-0 bg-secondary/5 pointer-events-none"></div> */}
                {/* <div className="absolute right-0 top-0 w-[500px] h-[500px] bg-secondary/10 blur-[100px] rounded-full mix-blend-multiply opacity-50 pointer-events-none"></div>
                <div className="absolute left-0 bottom-0 w-[500px] h-[500px] bg-primary/5 blur-[100px] rounded-full mix-blend-multiply opacity-50 pointer-events-none"></div> */}

                <div className="relative z-10 p-8 md:p-12 lg:p-16 flex flex-col h-full">
                    {/* Menu Header */}
                    <div className="flex justify-start items-center mb-8">
                        <button
                            onClick={onClose}
                            className="group p-2 cursor-pointer"
                        >
                            <X size={32} className="text-primary group-hover:text-secondary transition-colors duration-300 group-hover:rotate-90" strokeWidth={1} />
                        </button>
                    </div>

                    {/* Custom Navigation List */}
                    <motion.nav
                        initial="hidden"
                        animate={isOpen ? "visible" : "hidden"}
                        variants={{
                            hidden: { opacity: 0 },
                            visible: {
                                opacity: 1,
                                transition: { staggerChildren: 0.1, delayChildren: 0.3 }
                            }
                        }}
                        className="flex flex-col gap-6 md:gap-8 flex-1"
                    >
                        {/* Mobile Inquiry */}
                        <motion.div variants={{ hidden: { opacity: 0, x: -50 }, visible: { opacity: 1, x: 0 } }} className="lg:hidden mb-4">
                            <Link
                                to="/contact"
                                className="flex items-center gap-3 text-secondary text-lg"
                                onClick={onClose}
                            >
                                <span className="bg-secondary/10 p-2 rounded-full"><Phone size={16} /></span>
                                <span className="text-sm tracking-widest font-bold">INQUIRE NOW</span>
                            </Link>
                        </motion.div>

                        {/* Expandable Projects */}
                        <motion.div variants={{ hidden: { opacity: 0, x: -50 }, visible: { opacity: 1, x: 0 } }}>
                            <Link
                                to="/projects"
                                className={`text-3xl md:text-5xl font-serif font-light hover:text-secondary hover:translate-x-4 transition-all duration-300 block ${location.pathname === '/projects' ? 'text-secondary translate-x-4' : 'text-primary'}`}
                                onClick={onClose}
                            >
                                Projects
                            </Link>
                        </motion.div>
                        {/* <motion.div variants={{ hidden: { opacity: 0, x: -50 }, visible: { opacity: 1, x: 0 } }} className="group">
                            <button
                                onClick={() => toggleDropdown('ongoing')}
                                className={`flex items-center justify-between w-full text-left text-3xl md:text-5xl font-serif font-light hover:text-secondary hover:translate-x-4 transition-all duration-300 ${location.pathname.includes('project') ? 'text-secondary translate-x-4' : 'text-primary'}`}
                            >
                                <span>Projects</span>
                                <ChevronDown
                                    size={32}
                                    className={`text-secondary transform transition-transform duration-500 ${openDropdown === 'ongoing' ? 'rotate-180' : ''}`}
                                />
                            </button>
                            <div className={`overflow-hidden transition-all duration-500 ease-in-out ${openDropdown === 'ongoing' ? 'max-h-[300px] opacity-100 mt-4' : 'max-h-0 opacity-0'}`}>
                                <div className="flex flex-col gap-4 pl-4 border-l-2 border-secondary/20 ml-2">
                                    <Link to="/project/santvan-rizon" className="text-gray-500 hover:text-secondary transition-colors text-lg tracking-wider uppercase font-medium" onClick={onClose}>Valletta Vista</Link>
                                    <Link to="/project/santvan-heights" className="text-gray-500 hover:text-secondary transition-colors text-lg tracking-wider uppercase font-medium" onClick={onClose}>Valletta Rio</Link>
                                    <Link to="/project/green-valley" className="text-gray-500 hover:text-secondary transition-colors text-lg tracking-wider uppercase font-medium" onClick={onClose}>Valletta Homes</Link>
                                    <Link to="/project/green-valley" className="text-gray-500 hover:text-secondary transition-colors text-lg tracking-wider uppercase font-medium" onClick={onClose}>Valletta Villa</Link>
                                    <Link to="/project/green-valley" className="text-gray-500 hover:text-secondary transition-colors text-lg tracking-wider uppercase font-medium" onClick={onClose}>Valletta Rose Wood</Link>
                                </div>
                            </div>
                        </motion.div> */}

                        <motion.div variants={{ hidden: { opacity: 0, x: -50 }, visible: { opacity: 1, x: 0 } }}>
                            <Link
                                to="/about"
                                className={`text-3xl md:text-5xl font-serif font-light hover:text-secondary hover:translate-x-4 transition-all duration-300 block ${location.pathname === '/about' ? 'text-secondary translate-x-4' : 'text-primary'}`}
                                onClick={onClose}
                            >
                                About
                            </Link>
                        </motion.div>

                        <motion.div variants={{ hidden: { opacity: 0, x: -50 }, visible: { opacity: 1, x: 0 } }}>
                            <Link
                                to="/gallery"
                                className={`text-3xl md:text-5xl font-serif font-light hover:text-secondary hover:translate-x-4 transition-all duration-300 block ${location.pathname === '/gallery' ? 'text-secondary translate-x-4' : 'text-primary'}`}
                                onClick={onClose}
                            >
                                Gallery
                            </Link>
                        </motion.div>
                        <motion.div variants={{ hidden: { opacity: 0, x: -50 }, visible: { opacity: 1, x: 0 } }}>
                            <Link
                                to="/location"
                                className={`text-3xl md:text-5xl font-serif font-light hover:text-secondary hover:translate-x-4 transition-all duration-300 block ${location.pathname === '/location' ? 'text-secondary translate-x-4' : 'text-primary'}`}
                                onClick={onClose}
                            >
                                Location
                            </Link>
                        </motion.div>

                        <motion.div variants={{ hidden: { opacity: 0, x: -50 }, visible: { opacity: 1, x: 0 } }}>
                            <Link
                                to="/careers"
                                className={`text-3xl md:text-5xl font-serif font-light hover:text-secondary hover:translate-x-4 transition-all duration-300 block ${location.pathname === '/careers' ? 'text-secondary translate-x-4' : 'text-primary'}`}
                                onClick={onClose}
                            >
                                Careers
                            </Link>
                        </motion.div>
                        {/* <motion.div variants={{ hidden: { opacity: 0, x: -50 }, visible: { opacity: 1, x: 0 } }}>
                            <Link
                                to="/construction"
                                className={`text-3xl md:text-5xl font-serif font-light hover:text-secondary hover:translate-x-4 transition-all duration-300 block ${location.pathname === '/construction' ? 'text-secondary translate-x-4' : 'text-primary'}`}
                                onClick={onClose}
                            >
                                Construction
                            </Link>
                        </motion.div> */}

                        <motion.div variants={{ hidden: { opacity: 0, x: -50 }, visible: { opacity: 1, x: 0 } }}>
                            <Link
                                to="/support"
                                className={`text-3xl md:text-5xl font-serif font-light hover:text-secondary hover:translate-x-4 transition-all duration-300 block ${location.pathname === '/support' ? 'text-secondary translate-x-4' : 'text-primary'}`}
                                onClick={onClose}
                            >
                                Support
                            </Link>
                        </motion.div>

                        <motion.div variants={{ hidden: { opacity: 0, x: -50 }, visible: { opacity: 1, x: 0 } }}>
                            <Link
                                to="/contact"
                                className={`text-3xl md:text-5xl font-serif font-light hover:text-secondary hover:translate-x-4 transition-all duration-300 block ${location.pathname === '/contact' ? 'text-secondary translate-x-4' : 'text-primary'}`}
                                onClick={onClose}
                            >
                                Contacts
                            </Link>
                        </motion.div>
                    </motion.nav>

                    {/* Footer Info */}
                    <div className="relative z-10 mt-8 pt-8 border-t border-gray-200">
                        <p className="text-xs text-gray-400 tracking-wider">
                            &copy; {new Date().getFullYear()} VALLETTA GROUP. ALL RIGHTS RESERVED.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
